import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { PageHeader, StarRating, Badge, statusTone, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Star } from "lucide-react";
import { toast } from "sonner";

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const [tab, setTab] = useState("pending");
  const load = useCallback(() => api.get(`/reviews?status=${tab === "all" ? "" : tab}`).then(({ data }) => setReviews(data)), [tab]);
  useEffect(() => { load(); }, [load]);
  const moderate = async (r, status) => { await api.post(`/reviews/${r.id}/moderate`, { status }); toast.success(`Review ${status}`); load(); };
  return (
    <div data-testid="admin-reviews">
      <PageHeader title="Reviews & Ratings" subtitle="Moderate learner reviews" />
      <Tabs value={tab} onValueChange={setTab} className="mb-6"><TabsList><TabsTrigger value="pending">Pending</TabsTrigger><TabsTrigger value="approved">Approved</TabsTrigger><TabsTrigger value="hidden">Hidden</TabsTrigger><TabsTrigger value="all">All</TabsTrigger></TabsList></Tabs>
      {reviews.length === 0 ? <EmptyState icon={Star} title="No reviews" /> : (
        <div className="space-y-3">
          {reviews.map((r) => (
            <div key={r.id} className="bg-white border border-border rounded-lg p-5" data-testid={`review-${r.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-2"><span className="font-semibold text-navy">{r.user_name}</span><StarRating value={r.rating} size={13} /><Badge tone={statusTone(r.status)}>{r.status}</Badge></div>
                  <p className="text-navy/70 mt-2 text-sm">{r.comment}</p>
                </div>
                <div className="flex gap-2 shrink-0">
                  {r.status !== "approved" && <Button size="sm" className="bg-emerald-600 text-white" onClick={() => moderate(r, "approved")} data-testid={`approve-review-${r.id}`}>Approve</Button>}
                  {r.status !== "hidden" && <Button size="sm" variant="outline" onClick={() => moderate(r, "hidden")}>Hide</Button>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
